import { useCallback } from 'react';

import { FeedbackOrderType, OrderType } from '@sg/graphql-schema';

import { useSaveFeedbackCaseMutation } from '../GraphQL/RateOrder.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useSaveFeedbackCase = () => {
  const [execution, executeMutation] = useSaveFeedbackCaseMutation();

  const saveFeedbackCase = useCallback(
    async (input: {
      readonly orderId: string;
      readonly orderType: OrderType;
      readonly isFeedbackComplete: boolean;
    }) => {
      const feedbackOrderType = toFeedbackOrderType(input.orderType);

      if (!feedbackOrderType) {
        return;
      }

      return executeMutation({
        input: {
          orderId: input.orderId,
          orderType: feedbackOrderType,
          isFeedbackComplete: input.isFeedbackComplete,
        },
      });
    },
    [executeMutation],
  );

  return {
    saveFeedbackCase,
    isSubmitting: execution.fetching,
  };
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

const toFeedbackOrderType = (orderType: OrderType): FeedbackOrderType | null => {
  switch (orderType) {
    case OrderType.Delivery:
      return FeedbackOrderType.Delivery;
    case OrderType.InStore:
      return FeedbackOrderType.InStore;
    case OrderType.Pickup:
      return FeedbackOrderType.Pickup;
    default:
      return null;
  }
};
